export const industries = [
  'aerospace',
  'transportation',
  'computer_software_internet',
  'telecommunication',
  'food_and_agriculture',
  'construction',
  'education',
  'healthcare',
  'travel_and_hospitality',
  'entertainment_news_media_music',
  'energy',
  'manufacturing',
  'fashion_and_clothing',
  'mining',
  'consulting_services',
  'other'
]
